import React from 'react';

export const textCellRender = (props) => {
    const text =
        props.value !== undefined && props.value !== null
            ? props.value.toString()
            : props.value;

    return (
        <div className={`ag-wrapper ag-wrapper-text text-truncate`}>
            <span>{text}</span>
        </div>
    );
    /*
     return <i className={`icon icon-${props.value ? 'check' : 'cross'}`} />;
    */
};
